import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { Content } from '../../components/Content';
import { AnswersOnQuestionsContainer } from '../AnswersOnQuestionsContainer';
import { EarnWithCianContainer } from '../EarnWithCianContainer';
import { HighRewardContainer } from '../HighRewardContainer';
import { HowItWorksContainer } from '../HowItWorksContainer';
import { MakeMoneyContainer } from '../MakeMoneyContainer';
import { PrefooterContainer } from '../PrefooterContainer';

export const ContentContainer: React.FC = () => (
  <Content deviceType={useDeviceType()}>
    <EarnWithCianContainer />
    <MakeMoneyContainer />
    <HighRewardContainer />
    <HowItWorksContainer />
    <AnswersOnQuestionsContainer />
    <PrefooterContainer />
  </Content>
);
